'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    text-align: center !important;\n  '], ['\n    text-align: center !important;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: inline;\n  '], ['\n    display: inline;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _colors = require('HubStyleTokens/colors');

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _ItemConfigsSelectors = require('pricing-pages-unified-ui/selectors/ItemConfigsSelectors');

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FullPriceBlock = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'HighlightedMerchPriceDisplay__FullPriceBlock'
})(['color:', ';font-size:20px;font-weight:500;line-height:27px;display:block;'], _colors.PANTERA);

var FullPriceInline = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'HighlightedMerchPriceDisplay__FullPriceInline'
})(['color:', ';font-size:20px;font-weight:500;padding-left:7px;padding-right:7px;'], _colors.PANTERA);

var DiscountedPrice = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'HighlightedMerchPriceDisplay__DiscountedPrice'
})(['color:', ';font-size:20px;font-weight:500;padding-left:8px;'], _colors.OZ);

var CrossedOutPrice = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'HighlightedMerchPriceDisplay__CrossedOutPrice'
})(['color:', ';font-size:16px;line-height:27px;text-decoration:line-through;'], _colors.PANTERA);

var PriceSection = _styledComponents2.default.div.withConfig({
  displayName: 'HighlightedMerchPriceDisplay__PriceSection'
})(['text-align:right;', ''], _responsiveBreakpoints2.default.tablet(_templateObject));

var MicroCopy = (0, _styledComponents2.default)(_Small2.default).withConfig({
  displayName: 'HighlightedMerchPriceDisplay__MicroCopy'
})(['display:block;', ''], _responsiveBreakpoints2.default.tablet(_templateObject2));

var HighlightedMerchPriceDisplay = function HighlightedMerchPriceDisplay(_ref) {
  var merchandiseId = _ref.merchandiseId,
      activeCurrencyCode = _ref.activeCurrencyCode,
      pricingInfo = _ref.pricingInfo,
      showDiscountedPricing = _ref.showDiscountedPricing,
      inlinePriceDisplay = _ref.inlinePriceDisplay;

  var PriceComponent = inlinePriceDisplay ? FullPriceInline : FullPriceBlock;

  return _react2.default.createElement(
    PriceSection,
    {
      style: { textAlign: inlinePriceDisplay ? 'left' : null },
      className: inlinePriceDisplay ? 'm-top-5' : null
    },
    showDiscountedPricing ? _react2.default.createElement(_FormattedJSXMessage2.default, {
      message: 'pricingPage.discountedPricingPerMonth_jsx',
      options: {
        currencyCode: activeCurrencyCode,
        fullPrice: pricingInfo.monthly.fullPrice,
        discountedPrice: pricingInfo.monthly.calculatedPrice,
        merchandiseId: merchandiseId
      },
      elements: {
        MicroCopy: MicroCopy,
        DiscountedPrice: DiscountedPrice,
        CrossedOutPrice: CrossedOutPrice
      }
    }) : _react2.default.createElement(_FormattedJSXMessage2.default, {
      message: 'pricingPage.pricingPerMonth_jsx',
      options: {
        currencyCode: activeCurrencyCode,
        price: pricingInfo.monthly.calculatedPrice,
        merchandiseId: merchandiseId
      },
      elements: {
        MicroCopy: inlinePriceDisplay ? _Small2.default : MicroCopy,
        Price: PriceComponent
      }
    })
  );
};

HighlightedMerchPriceDisplay.propTypes = {
  pricingInfo: _react.PropTypes.object.isRequired,
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  showDiscountedPricing: _react.PropTypes.bool.isRequired,
  inlinePriceDisplay: _react.PropTypes.bool,
  merchandiseId: _react.PropTypes.number.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId,
      activeTerm = _ref2.activeTerm;

  var termId = activeTerm ? (0, _ItemConfigsSelectors.termIdFromTermSelector)(state, activeTerm, merchandiseId) : (0, _ItemConfigsSelectors.defaultTermIdSelector)(state, merchandiseId);

  return {
    pricingInfo: (0, _PricingSelectors.calculatedPriceSelector)(state, {
      termId: termId,
      itemConfigurations: [{ merchandiseId: merchandiseId, quantity: 1 }]
    }),
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    showDiscountedPricing: (0, _PromotionSelectors.showDiscountedPricingSelector)(state, merchandiseId, activeTerm)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HighlightedMerchPriceDisplay);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/HighlightedMerchPriceDisplay.js
// module id = 597
// module chunks = 3 4